import { render } from "./PortraitsCollections.vue?vue&type=template&id=1871ac82&scoped=true"
import script from "./PortraitsCollections.vue?vue&type=script&lang=js"
export * from "./PortraitsCollections.vue?vue&type=script&lang=js"

import "./PortraitsCollections.vue?vue&type=style&index=0&id=1871ac82&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1871ac82"]])

export default __exports__